module.exports = __webpack_public_path__ + "img/Jhearts.979bd749.jpg";